import type { RefOrGetter } from '@/helpers'
import { computed, type ComputedRef, toValue } from 'vue'

export function usePageCount(
    total: RefOrGetter<number>,
    limit: RefOrGetter<number>
): ComputedRef<number> {
    return computed(() => {
        const limitVal = toValue(limit)

        if (0 === limitVal) {
            return 0
        }

        return Math.ceil(toValue(total) / limitVal)
    })
}
